var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListOfPersonsMinWithFullName',{staticClass:"title-sm",attrs:{"label":_vm.label,"count":_vm.count,"value":_vm.listOfPeopels},on:{"select":_vm.selectAgentHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }